import { AutogenLayoutOffice401kHistory } from "./autogen/AutogenLayoutOffice401kHistory";
import { DataSourceMode, DataSourceModeChangeEvent, LookupModelSearchEvent } from "@mcleod/components";

export class Office401kHistory extends AutogenLayoutOffice401kHistory {
    onLoad(): void | Promise<void> {
        this.layoutGLDistribution.replaceMainDatasource(this.sourceJournalOffice);
        this.layoutGLDistribution.tableGLDistribution.removeColumn("columnHeaderOrderNumber");
        this.textboxDeductionId.addBeforeLookupModelSearchListener((event: LookupModelSearchEvent) => {
            event.filter = "deduction_type IN ('B','D')";
        });
    }

    sourceOff401kHistAfterModeChange(event: DataSourceModeChangeEvent) {
        this.dataheaderOffice401kHistory.showExecute = event.newMode === DataSourceMode.SEARCH;
    }
}
